import React from 'react';
import { openStoreLocatorSidebar } from '../StoreLocator/storeLocatorSidebarState';
import './style.scss';

const StockIndicator = ({
  isAvailable,
  textWhenAvailable,
  textWhenUnavailable,
  cta,
  isCart = false,
}: {
  isAvailable: boolean;
  textWhenAvailable: string;
  textWhenUnavailable: string;
  cta?: string | null;
  isCart?: boolean;
}) => (
  <div className="stock-indicator">
    <div>
      <div className={isAvailable ? 'stock-indicator__available' : 'stock-indicator__unavailable'}></div>
    </div>
    <div className="stock-indicator-text-wrapper ">
      <p className={`stock-indicator-text ${isCart ? 'no-wrap' : ''}`}>
        {isAvailable ? textWhenAvailable : textWhenUnavailable}
      </p>
      {cta ? (
        <button
          type="button"
          className="plain-button"
          onClick={() => {
            openStoreLocatorSidebar({ feature: 'bopis', page: 'cart' });
          }}
        >
          {cta}
        </button>
      ) : null}
    </div>
  </div>
);

export default StockIndicator;
